module.exports = __webpack_public_path__ + "static/media/Poppins-Light-latin.8d91ec1c.woff2";